<template>
    <div class="auth-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ $t('authEmail.authentication') }}</div>
        </header>

        <main class="page-content">
            <section class="auth-card">
                <div class="auth-header">
                    <h1>{{ $t('authEmail.authentication') }}</h1>
                    <p>
                        {{ $t('authEmail.tip') }}
                        <span>{{ data.mobile }}</span>
                    </p>
                </div>

                <div class="form-group">
                    <label class="field-label">{{ $t('authEmail.code') }}</label>
                    <div class="code-wrap">
                        <input
                            v-model.trim="code"
                            type="text"
                            class="text-input"
                            :placeholder="$t('authEmail.code')"
                        >
                        <van-count-down
                            :time="time"
                            class="countdown"
                            @finish="timeCall"
                        >
                            <template v-slot="timeData">
                                <button
                                    type="button"
                                    class="code-btn"
                                    :disabled="timeData.seconds > 0 || is_send"
                                    @click="sendcode"
                                >
                                    {{ timeData.seconds > 0 ? timeData.seconds + 's' : $t('authEmail.sendcode') }}
                                </button>
                            </template>
                        </van-count-down>
                    </div>
                </div>
            </section>

            <button type="button" class="submit-btn" :class="{ disabled: !code }" @click="submit">
                {{ $t('authEmail.submit') }}
            </button>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Icon, Toast } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown).use(Icon).use(Toast);

export default {
    name: "authEmail",
    data() {
        return {
            data: {},
            time: 0,
            code: "",
            is_send: false,
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        start() {
            Fetch("/user/info").then((r) => {
                this.data = r.data || {};
            });
        },
        timeCall() {
            this.is_send = false;
            this.time = 0;
        },
        sendcode() {
            if (this.is_send) {
                return;
            }
            this.is_send = true;
            Fetch("/index/auth_email_code").then(() => {
                this.time = 60 * 1000;
                this.$toast({
                    className: "toastName",
                    message: this.$t("authEmail.sendsuccess"),
                });
            }).catch(() => {
                this.is_send = false;
            });
        },
        submit() {
            if (!this.code) {
                this.$toast(this.$t("authEmail.codeEmpty"));
                return false;
            }
            Fetch("/user/auth_email", {
                code: this.code,
            }).then(() => {
                this.$toast({
                    className: "toastName",
                    message: this.$t("authEmail.success"),
                });
                if (this.$route.query.redirect) {
                    this.$router.replace(this.$route.query.redirect + "&money=" + this.$route.query.money);
                } else {
                    this.$router.replace("/safe");
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.auth-page {
    min-height: 100vh;
    background: #000;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.auth-card {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
}

.auth-card {
    padding: 22px 18px;
    margin-bottom: 22px;
}

.auth-header {
    margin-bottom: 24px;
}

.auth-header h1 {
    margin: 0 0 10px;
    color: #fff;
    font-size: 26px;
    font-weight: 800;
}

.auth-header p {
    margin: 0;
    color: rgba(255, 255, 255, 0.56);
    font-size: 13px;
    line-height: 1.7;
}

.auth-header p span {
    display: block;
    margin-top: 6px;
    color: #2d5bff;
    font-size: 16px;
    font-weight: 700;
}

.field-label {
    display: block;
    margin: 0 0 12px 2px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
}

.code-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 56px;
    padding: 0 12px 0 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.02);
}

.text-input {
    flex: 1;
    min-width: 0;
    border: 0;
    outline: none;
    background: transparent;
    color: #fff;
    font-size: 15px;
}

.text-input::placeholder {
    color: rgba(255, 255, 255, 0.28);
}

.countdown {
    flex-shrink: 0;
}

.code-btn {
    min-width: 98px;
    height: 38px;
    padding: 0 12px;
    border: 0;
    border-radius: 10px;
    background: rgba(45, 91, 255, 0.12);
    color: #2d5bff;
    font-size: 13px;
    font-weight: 700;
}

.code-btn[disabled] {
    opacity: 0.6;
}

.submit-btn {
    width: 100%;
    height: 48px;
    border: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, #2d5bff 0%, #104af0 100%);
    box-shadow: 0 4px 15px rgba(45, 91, 255, 0.3);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}

.submit-btn.disabled {
    opacity: 0.55;
}
</style>
